import { Outlet, useLocation } from 'react-router-dom';
import { Nav } from '@/components/nav/Nav';
import { SidebarInset, SidebarProvider } from '@/components/ui/sidebar';
import { CalendarSyncDialog } from '@/features/calendar-sync/components/CalendarSyncDialog';
import { useNavStore } from '@/stores/useNavStore';

export default function App() {
  const location = useLocation();
  const calendarSyncOpen = useNavStore((s) => s.calendarSyncOpen);
  const setCalendarSyncOpen = useNavStore((s) => s.setCalendarSyncOpen);

  // Only show footer on main schedule view (home page)
  const showFooter = location.pathname === '/';

  return (
    <SidebarProvider defaultOpen={false}>
      <Nav />
      <SidebarInset className="h-svh min-w-0 bg-background text-foreground">
        {/* Block scroll container (not flex-col): flex-1 page roots were stretching to ~100vh and
            capped position:sticky for Headers to one viewport.
            min-w-0 on the inset + scroll wrapper so the page reflows when the
            sidebar toggles instead of producing a horizontal scrollbar. */}
        <div className="min-h-0 min-w-0 flex-1 overflow-y-auto">
          <Outlet />
        </div>
        {showFooter && (
          <footer className="border-t border-border/60 bg-card/80 backdrop-blur">
            <div className="mx-auto flex w-full max-w-7xl items-center justify-center px-4 py-3 sm:px-6 lg:px-8">
              <div className="text-xs text-muted-foreground">
                Transparent Imaging • Scheduler
              </div>
            </div>
          </footer>
        )}
      </SidebarInset>

      <CalendarSyncDialog open={calendarSyncOpen} onOpenChange={setCalendarSyncOpen} />
    </SidebarProvider>
  );
}
